export default __webpack_public_path__ + "static/media/Inhaler 3.36928ae2.png";